export const gdpr = {
  routes: [
    {
      path: "/department-process/:department",
      component: () => import("../organization-department-process-view"),
    },
  ],
};
